/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { AppDispatch } from 'src/app/store';
import { Modal } from '@dsny/dsny-component-library';
import { trackModalView } from 'src/utils/segmentService';
import {
  ButtonStyleWrapper,
  FlexButtonWrapper,
  HeadingImportReleaseModal,
  ReleaseAndArtistStyle,
  ReleaseAndArtistWrapper,
  SubTextImportReleaseModal,
} from './ImportRelease.styles';
import { cleanReleasesNotAuthorized } from '../MultiAsset.slice';

// define props type
interface ImportReleaseNoAccessModalProps {
  show: boolean;
  setShowNoAccessModal: (show: boolean) => void;
  releases_not_authorized: string[];
}

export const ImportReleaseNoAccessModal = ({
  show,
  setShowNoAccessModal,
  releases_not_authorized,
}: ImportReleaseNoAccessModalProps) => {
  const { t } = useTranslation();
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    if (releases_not_authorized.length > 0) {
      setShowNoAccessModal(true);
    }
  }, [releases_not_authorized]);

  const closeModal = () => {
    // dispatch cleanreleasesNotAuthorized action here if needed
    dispatch(cleanReleasesNotAuthorized());
    setShowNoAccessModal(false);
  };

  return (
    // User don’t have access to this release(s) - (Import Release from Caster)
    <Modal
      isOpen={show}
      onClose={() => closeModal()}
      analyticsModalType="import_release_no_access_modal"
      trackEvent={trackModalView}
      containerStyles={{
        width: '608px',
        height: 'fit-content',
        padding: '32px',
      }}
    >
      <HeadingImportReleaseModal className="heading">
        {t('IMPORT_RELEASE_NO_ACCESS_MODAL_TITLE')}
      </HeadingImportReleaseModal>

      <SubTextImportReleaseModal>
        {t('IMPORT_RELEASE_NO_ACCESS_MODAL_DESC')}
      </SubTextImportReleaseModal>

      <ReleaseAndArtistWrapper>
        {releases_not_authorized.map((title: string) => (
          <ReleaseAndArtistStyle key={title}>{title}</ReleaseAndArtistStyle>
        ))}
      </ReleaseAndArtistWrapper>

      <SubTextImportReleaseModal>
        {t('IMPORT_RELEASE_NO_ACCESS_MODAL_NOTE')}
      </SubTextImportReleaseModal>

      <div className="footer">
        <FlexButtonWrapper>
          <ButtonStyleWrapper
            setting="mtr"
            fontSize="14px"
            type="button"
            onClick={() => closeModal()}
          >
            {t('IMPORT_RELEASE_NO_ACCESS_MODAL_CONTINUE_CTA')}
          </ButtonStyleWrapper>
        </FlexButtonWrapper>
      </div>
    </Modal>
  );
};
